import tabsession from "../../../../assets/images/blogs/pp14/tabsession.png";
import tabpane from "../../../../assets/images/blogs/pp14/tabpane.png";
import * as React from 'react';
export default {
  tabsession,
  tabpane,
  React
};